var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_2d = require("editor-2d");
var cio_config = require('cio-config');
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");

var SymbolGeneratorHandleModel = require("./symbolGeneratorHandleModel.js");
var SymbolGeneratorTerminalInteractionModel = require("./symbolGeneratorTerminalInteractionModel.js");

var SymbolGeneratorInteractionModel = function (symbolGeneratorData, editorModel) {
    var self = this;

    editor_2d.AbstractPosAngleInteractionModel.call(this, symbolGeneratorData, editorModel, {angle_restriction: [0, 90, 180, 270]});

    this.boundingBox = this.data.boundingBox;

    this.handle = this.value("handle", true);
    this.handle(new SymbolGeneratorHandleModel(this));

    this.terminalInteractionModelList = this.list("terminalIMList", true);

    // create subInteractionModels for each terminal
    var createSubInteractionModels = function (nameList) {
        var getOffset = function (list) {
            switch (list) {
                case self.data.leftNameList:
                    return 0;
                case self.data.bottomNameList:
                    return self.data.leftNameList.size();
                case self.data.rightNameList:
                    return self.data.leftNameList.size()+self.data.bottomNameList.size();
                case self.data.topNameList:
                    return self.data.leftNameList.size()+self.data.bottomNameList.size()+self.data.rightNameList.size()
            }
        };
        nameList.onAdd("addedTerminal", function(idx, name) {
            self.terminalInteractionModelList.add(getOffset(this)+idx, new SymbolGeneratorTerminalInteractionModel(this, idx));
        }, 10);
        nameList.onRemove("removedTerminal", function(idx, name) {
            self.terminalInteractionModelList.remove(getOffset(this)+idx);
        }, 10);
        nameList.forEach(function(idx, name) {
            self.terminalInteractionModelList.add(getOffset(nameList)+idx, new SymbolGeneratorTerminalInteractionModel(nameList, idx));
        });
    };

    createSubInteractionModels(this.data.leftNameList);
    createSubInteractionModels(this.data.bottomNameList);
    createSubInteractionModels(this.data.rightNameList);
    createSubInteractionModels(this.data.topNameList);

    // change width / height when names are updated
    function updateWidthHeight(){
        var minBoxWidth = self.data.getMinBoxWidth();
        if(self.data.width() < minBoxWidth) self.data.width(minBoxWidth);
        var minBoxHeight = self.data.getMinBoxHeight();
        if(self.data.height() < minBoxHeight) self.data.height(minBoxHeight);
    }

    this.data.topNameList.onBubble("updateWidthHeight", updateWidthHeight);
    this.data.bottomNameList.onBubble("updateWidthHeight", updateWidthHeight);
    this.data.leftNameList.onBubble("updateWidthHeight", updateWidthHeight);
    this.data.rightNameList.onBubble("updateWidthHeight", updateWidthHeight);

    this.showCTop = this.shadow("showCTop",
        function () {
            return this.data.topNameList.size();
        },
        function (value) {
            if (isNaN(value)) return false;
            var cTop = this.data.topNameList.size();
            if(value > cTop) {
                for(var i=0; i<(value-cTop); i++) {
                    var name = this.data.parent().terminalNames.getProposal(); // TODO: maybe the nameManger should be passed by the manifest
                    this.data.topNameList.push(name);
                }
            } else if (value < cTop) {
                for(var i=0; i<(cTop-value); i++) {
                    this.data.topNameList.pop();
                }
            }
            return true;
        },
        [this.data.topNameList]
    );

    this.showCBottom = this.shadow("showCBottom", 
        function () {
            return this.data.bottomNameList.size();
        },
        function (value) {
            if (isNaN(value)) return false;
            var cBottom = this.data.bottomNameList.size();
            if(value > cBottom) {
                for(var i=0; i<(value-cBottom); i++) {
                    var name = this.data.parent().terminalNames.getProposal();
                    this.data.bottomNameList.push(name);
                }
            } else if (value < cBottom) {
                for(var i=0; i<(cBottom-value); i++) {
                    this.data.bottomNameList.pop();
                }
            }
            return true;
        },
        [this.data.bottomNameList]
    );

    this.showCLeft = this.shadow("showCLeft",
        function () {
            return this.data.leftNameList.size();
        },
        function (value) {
            if (isNaN(value)) return false;
            var cLeft = this.data.leftNameList.size();
            if(value > cLeft) {
                for(var i=0; i<(value-cLeft); i++) {
                    var name = this.data.parent().terminalNames.getProposal();
                    this.data.leftNameList.push(name);
                }
            } else if (value < cLeft) {
                for(var i=0; i<(cLeft-value); i++) {
                    this.data.leftNameList.pop();
                }
            }
            return true;
        },
        [this.data.leftNameList]
    );

    this.showCRight = this.shadow("showCRight",
        function () {
            return this.data.rightNameList.size();
        },
        function (value) {
            if (isNaN(value)) return false;
            var cRight = this.data.rightNameList.size();
            if(value > cRight) {
                for(var i=0; i<(value-cRight); i++) {
                    var name = this.data.parent().terminalNames.getProposal();
                    this.data.rightNameList.push(name);
                }
            } else if (value < cRight) {
                for(var i=0; i<(cRight-value); i++) {
                    this.data.rightNameList.pop();
                }
            }
            return true;
        },
        [this.data.rightNameList]
    );

};
lib_core.inherit(SymbolGeneratorInteractionModel, editor_2d.AbstractPosAngleInteractionModel);
lib_core.JsonParser.registerClass(SymbolGeneratorInteractionModel, "SymbolGeneratorInteractionModel");

module.exports = SymbolGeneratorInteractionModel;

SymbolGeneratorInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = editor_2d.AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPAND_CLICK)
        .element(this);

    inspectorElements.input_elements.push(
        {
            label      : 'CLeft',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showCLeft,
            datatype    : cio_config.types.positive_int
        },
        {
            label      : 'CRight',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showCRight,
            datatype    : cio_config.types.positive_int
        },
        {
            label      : 'CTop',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showCTop,
            datatype    : cio_config.types.positive_int
        },
        {
            label      : 'CBottom',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showCBottom,
            datatype    : cio_config.types.positive_int
        },
        {
            label      : 'Expand',
            type       : ui_extensions.InspectorInputType.BUTTON,
            cEvent     : cEvent
        }
    );

    inspectorElements.help_elements = {
        'name': 'Generator Tool'
    };

    return inspectorElements;
};

SymbolGeneratorInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new editor_2d.SnapSet();

    snapSet.addHor(this.data.pos(), 2);
    snapSet.addVer(this.data.pos(), 2);

    var upper_left  = this.data.pos().sub(new lib_geometry.Coord(this.data.width()/2,this.data.height()/2));
    var lower_right = this.data.pos().add(new lib_geometry.Coord(this.data.width()/2,this.data.height()/2));

    snapSet.addVer(upper_left , 1);
    snapSet.addHor(upper_left , 1);

    snapSet.addVer(lower_right , 1);
    snapSet.addHor(lower_right , 1);

    return snapSet;
};

SymbolGeneratorInteractionModel.prototype.flip = function (flipline) {
    if(flipline !== undefined) {
        this.data.pos(this.data.pos().flip(flipline));
    }
};
